/**
 * import React, { useEffect, useState } from 'react';
 * import toast from 'react-hot-toast';
 * import { BsImages } from 'react-icons/bs';
 * import { useDispatch, useSelector } from 'react-redux';
 * import { FadeLoader, PropagateLoader } from 'react-spinners';
 *
 * import Footer from '../components/Footer';
 * import Headers from '../components/Headers';
 * import { customer_login, messageClear } from '../store/reducers/authReducer';
 * import { useCategories } from '../utils/Categories';
 * import { overrideStyle } from '../utils/utils';
 *
 * const SellOnGobymall = () => {
 *     const [authStep, setAuthStep] = useState(null); // 'login' ou 'register'
 *     const [isLoggedInStepDone, setIsLoggedInStepDone] = useState(false);
 *
 *     const { categories, loading, errorMessage } = useCategories();
 *     const dispatch = useDispatch();
 *     const { customerInfo, loader, successMessage } = useSelector(state => state.auth);
 *     const [state, setState] = useState({
 *         country: '',
 *         city: '',
 *         shopName: '',
 *         address: '',
 *         telephone: '',
 *         email : customerInfo.email || '',
 *         password : ''
 *     });
 *
 *     const [logState, setLogState] = useState({
 *                 email: '',
 *                 password: '',
 *       })
 *       const inputLogHandle = (e) => {
 *         setLogState({ ...logState, [e.target.name]: e.target.value })
 *       }
 *
 *
 *     const handleBack = () => {
 *         if (authStep === 'register') {
 *             setAuthStep(null);
 *         } else if (authStep === 'login' && isLoggedInStepDone) {
 *             setIsLoggedInStepDone(false);
 *         } else {
 *             setAuthStep(null);
 *         }
 *     };
 *
 *     const add_image = (e) => {
 *         if (e.target.files.length > 0) {
 *             const formData = new FormData();
 *             formData.append('image', e.target.files[0]);
 *             // dispatch(profile_image_upload(formData))
 *         }
 *     };
 *
 *     const inputHandle = (e) => {
 *         setState({
 *             ...state,
 *             [e.target.name]: e.target.value
 *         });
 *     };
 *
 *
 *     const handleLoginSubmit = (e) => {
 *         e.preventDefault();
 *         setIsLoggedInStepDone(true);
 *         dispatch(customer_login(logState))
 *     };
 *
 *     const add = (e) => {
 *         e.preventDefault();
 *         // dispatch(profile_info_add(state))
 *     };
 *
 *     useEffect(() => {
 *         if (successMessage) {
 *             toast.success(successMessage);
 *             dispatch(messageClear());
 *         }
 *     }, [successMessage, dispatch]);
 *
 *     return (
 *         <div>
 *
 *             <Headers categories={categories} />
 *             {loading && (
 *                 <div className='w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-gray-500/70 z-[99999]'>
 *                     <FadeLoader />
 *                 </div>
 *             )}
 *
 *             {errorMessage && (
 *                 <div className='w-full text-ellipsis text-3xl font-bold text-red-600'>
 *                     Error: {errorMessage}
 *                 </div>
 *             )}
 *
 *             <div className='min-w-screen min-h-screen flex justify-center items-center shadow bg-[#eaebed] text-slate-500'>
 *                 <div className='w-[50%] md-lg:w-[95%] p-4'>
 *                     <div className='w-full p-4 rounded-md bg-white'>
 *
 *                         {// Choix initial }
 *                         {!customerInfo && !authStep && (
 *                             <div className='text-center '>
 *                                 <h2 className='text-xl mb-10'>Vous devez être connecté pour continuer</h2>
 *                                 <div className='flex gap-4 justify-center'>
 *                                     <button onClick={() => setAuthStep('login')} className='bg-blue-600 text-white px-4 py-2 rounded'>Se connecter</button>
 *                                     <button onClick={() => setAuthStep('register')} className='bg-green-600 text-white px-4 py-2 rounded'>Créer un compte</button>
 *                                 </div>
 *                                <div className='flex w-full justify-center items-center'>
 *                                  <img className='h-[350px] w-auto text-center opacity-45' src="/images/shiapp.jpg" alt="" />
 *                                </div>
 *                             </div>
 *                         )}
 *
 *                         {// Formulaire Login }
 *                         {!customerInfo && authStep === 'login' && !isLoggedInStepDone && (
 *                             <form onSubmit={handleLoginSubmit} className='mb-5'>
 *                                 <h2 className='text-center font-roboto text-xl my-4'>Connectez au compte client pour créer le compte vendeur</h2>
 *                                 <div className='flex flex-col gap-1 mb-2'>
 *                                   <label htmlFor="email">Email</label>
 *                                     <input onChange={inputLogHandle} value={logState.email}  type="email" name='email' id='email' placeholder='Your email' className='w-full px-3 py-2 border border-slate-200
 *                                     outline-none focus:border-indigo-500rounded-md '/>
 *                                 </div>
 *                                 <div className='flex flex-col gap-1 my-2'>
 *                                         <label htmlFor="password">Password</label>
 *                                             <input onChange={inputLogHandle} value={logState.password}  type="password" name='password' id='password' placeholder='your password' className='w-full px-3 py-2 border
 *                                             border-slate-200 outline-none focus:border-indigo-500rounded-md '/>
 *                                 </div>
 *                                 <div className='flex gap-3'>
 *                                     <button type="submit" className='bg-blue-500 text-white px-4 py-2 rounded w-full'>Connexion</button>
 *                                     <button type="button" onClick={handleBack} className='bg-gray-400 text-white px-4 py-2 rounded'>Retour</button>
 *                                 </div>
 *                                 <div className='flex w-full justify-center items-center'>
 *                                  <img className='h-[350px] w-auto text-center opacity-45' src="/images/shiapp.jpg" alt="" />
 *                                </div>
 *                             </form>
 *                         )}
 *
 *                         {// Formulaire principal }
 *                         {(customerInfo || authStep === 'register' || (authStep === 'login' && isLoggedInStepDone)) && (
 *                             <form onSubmit={add}>
 *                                 {// Upload image }
 *                                 <div className='flex justify-center items-center py-3'>
 *                                     <label className='flex justify-center items-center flex-col h-[210px] w-[300px] cursor-pointer border border-dashed hover:border-indigo-500 border-[#d0d2d6] relative' htmlFor="img">
 *                                         <BsImages />
 *                                         <span>Sélectionner une image</span>
 *                                         {loader && (
 *                                             <div className='bg-slate-600 absolute left-0 top-0 w-full h-full opacity-70 flex justify-center items-center z-20'>
 *                                                 <FadeLoader />
 *                                             </div>
 *                                         )}
 *                                     </label>
 *                                     <input onChange={add_image} type="file" className='hidden' id='img' />
 *                                 </div>
 *
 *                                 {//Champs de formulaire }
 *                                 <div className='flex flex-col gap-3'>
 *                                     <InputField label="Nom de la boutique" name="shopName" value={state.shopName} onChange={inputHandle} />
 *                                     <InputField label="Pays" name="country" value={state.division} onChange={inputHandle} />
 *                                     <InputField label="Ville" name="city" value={state.district} onChange={inputHandle} />
 *                                     <InputField label="address" name="addresse" value={state.sub_district} onChange={inputHandle} />
 *                                     <InputField label="Téléphone" name="telephone" value={state.telephone} onChange={inputHandle} type="tel" />
 *
 *                                     {!customerInfo && (
 *                                         <>
 *                                             <InputField label="Email" name="email" type="email" required />
 *                                             <InputField label="Mot de passe" name="password" type="password" required />
 *                                         </>
 *                                     )}
 *                                 </div>
 *
 *                                 {// Boutons }
 *                                 <div className='flex gap-3 mt-4'>
 *                                     <button disabled={loader} className='bg-blue-500 text-white rounded-md px-7 py-2 w-full'>
 *                                         {loader ? <PropagateLoader color='#fff' cssOverride={overrideStyle} /> : 'Soumettre'}
 *                                     </button>
 *                                     {!customerInfo && (
 *                                         <button type="button" onClick={handleBack} className='bg-gray-400 text-white rounded-md px-7 py-2'>
 *                                             Retour
 *                                         </button>
 *                                     )}
 *                                 </div>
 *                             </form>
 *                         )}
 *                     </div>
 *                 </div>
 *             </div>
 *             <Footer />
 *         </div>
 *     );
 * };
 *
 * const InputField = ({ label, name, value, onChange, type = 'text', required = true }) => (
 *     <div className='flex flex-col gap-1'>
 *         <label htmlFor={name}>{label}</label>
 *         <input
 *             type={type}
 *             name={name}
 *             id={name}
 *             placeholder={label}
 *             value={value}
 *             onChange={onChange}
 *             required={required}
 *             className='px-4 py-2 border border-slate-300 rounded-md focus:border-indigo-500 outline-none'
 *         />
 *     </div>
 * );
 *
 * export default SellOnGobymall;
 *
 * @format
 */

/*
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { BsImages } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { FadeLoader, PropagateLoader } from 'react-spinners';

import Footer from '../components/Footer';
import Headers from '../components/Headers';
import { createSellerAccount, customer_login, messageClear } from '../store/reducers/authReducer';
import { useCategories } from '../utils/Categories';
import { overrideStyle } from '../utils/utils';

const SellOnGobymall = () => {
    const [authStep, setAuthStep] = useState(null); // 'login' ou 'register'
    const [isLoggedInStepDone, setIsLoggedInStepDone] = useState(false);

    const { categories, loading, errorMessage } = useCategories();
    const dispatch = useDispatch();
    const { customerInfo, loader, successMessage } = useSelector(state => state.auth);

    const [state, setState] = useState({
        country: '',
        city: '',
        shopName: '',
        address: '',
        telephone: '',
        email: '',
        password: '',
    });

    const [logState, setLogState] = useState({
        email: '',
        password: '',
    });

    const inputLogHandle = (e) => {
        setLogState({ ...logState, [e.target.name]: e.target.value });
    };

    const handleBack = () => {
        if (authStep === 'register') {
            setAuthStep(null);
        } else if (authStep === 'login' && isLoggedInStepDone) {
            setIsLoggedInStepDone(false);
        } else {
            setAuthStep(null);
        }
    };

    const inputHandle = (e) => {
        setState({
            ...state,
            [e.target.name]: e.target.value,
        });
    };

    const handleLoginSubmit = (e) => {
        e.preventDefault();
        setIsLoggedInStepDone(true);
        dispatch(customer_login(logState));
    };

    const add = (e) => {
        e.preventDefault();
        const file = e.target.files[0];
        // console.log("Image chargée :", file);
       
         if (!file) {
           alert("Veuillez sélectionner un fichier.");
           return;
         }
       
         const formData = new FormData();
         formData.append("image", file);
       
         // Afficher le contenu de FormData pour validation
         for (const [key, value] of formData.entries()) {
           console.log(`Clé  : ${key}, Valeur :`, value);
         }

        const sellerData = {
            shopName: state.shopName,
            email: customerInfo?.email || state.email,
            password: customerInfo ? undefined : state.password,
            country: state.country,
            city: state.city,
            address: state.address,
            telephone: state.telephone,
        };

        console.log('Envoi des données vendeur :', sellerData);
        dispatch(createSellerAccount({sellerData, formData}))
    };

    useEffect(() => {
        if (successMessage) {
            toast.success(successMessage);
            dispatch(messageClear());
        }
    }, [successMessage, dispatch]);

    return (
        <div>
            <Headers categories={categories} />

            {loading && (
                <div className='w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-gray-500/70 z-[99999]'>
                    <FadeLoader />
                </div>
            )}

            {errorMessage && (
                <div className='w-full text-ellipsis text-3xl font-bold text-red-600'>
                    Error: {errorMessage}
                </div>
            )}

            <div className='min-w-screen min-h-screen flex justify-center items-center shadow bg-[#eaebed] text-slate-500'>
                <div className='w-[50%] md-lg:w-[95%] p-4'>
                    <div className='w-full p-4 rounded-md bg-white'>
                        {// Étape de choix }
                        {!customerInfo && !authStep && (
                            <div className='text-center'>
                                <h2 className='text-xl mb-10'>Vous devez être connecté pour continuer</h2>
                                <div className='flex gap-4 justify-center'>
                                    <button onClick={() => setAuthStep('login')} className='bg-blue-600 text-white px-4 py-2 rounded'>Se connecter</button>
                                    <button onClick={() => setAuthStep('register')} className='bg-green-600 text-white px-4 py-2 rounded'>Créer un compte</button>
                                </div>
                                <div className='flex w-full justify-center items-center'>
                                    <img className='h-[350px] w-auto text-center opacity-45' src="/images/shiapp.jpg" alt="" />
                                </div>
                            </div>
                        )}

                        {// Formulaire de connexion }
                        {!customerInfo && authStep === 'login' && !isLoggedInStepDone && (
                            <form onSubmit={handleLoginSubmit} className='mb-5 flex flex-col gap-4'>
                                <h2 className='text-center font-roboto text-xl my-4'>Connectez-vous pour créer le compte vendeur</h2>
                                <InputField label="Email" name="email" value={logState.email} onChange={inputLogHandle} type="email" />
                                <InputField label="Mot de passe" name="password" value={logState.password} onChange={inputLogHandle} type="password" />
                                <div className='flex gap-3 mt-3'>
                                    <button type="submit" className='bg-blue-500 text-white px-4 py-2 rounded w-full'>Connexion</button>
                                    <button type="button" onClick={handleBack} className='bg-gray-400 text-white px-4 py-2 rounded'>Retour</button>
                                </div>
                                <div className='flex w-full justify-center items-center mt-5'>
                                    <img className='h-[350px] w-auto text-center opacity-45' src="/images/shiapp.jpg" alt="" />
                                </div>
                            </form>
                        )}

                        {// Formulaire principal }
                        {(customerInfo || authStep === 'register' || (authStep === 'login' && isLoggedInStepDone)) && (
                            <form onSubmit={add}>
                                {/* Upload image }
                                <div className='flex justify-center items-center py-3'>
                                    <label className='flex justify-center items-center flex-col h-[210px] w-[300px] cursor-pointer border border-dashed hover:border-indigo-500 border-[#d0d2d6] relative' htmlFor="img">
                                        <BsImages />
                                        <span>Sélectionner une image</span>
                                        {loader && (
                                            <div className='bg-slate-600 absolute left-0 top-0 w-full h-full opacity-70 flex justify-center items-center z-20'>
                                                <FadeLoader />
                                            </div>
                                        )}
                                    </label>
                                    <input  type="file" className='hidden' id='img' />
                                </div>

                                {// Champs texte }
                                <div className='flex flex-col gap-3'>
                                    <InputField label="Nom de la boutique" name="shopName" value={state.shopName} onChange={inputHandle} />
                                    <InputField label="Pays" name="country" value={state.country} onChange={inputHandle} />
                                    <InputField label="Ville" name="city" value={state.city} onChange={inputHandle} />
                                    <InputField label="Adresse" name="address" value={state.address} onChange={inputHandle} />
                                    <InputField label="Téléphone" name="telephone" value={state.telephone} onChange={inputHandle} type="tel" />
                                    {!customerInfo && (
                                        <>
                                            <InputField label="Email" name="email" value={state.email} onChange={inputHandle} type="email" />
                                            <InputField label="Mot de passe" name="password" value={state.password} onChange={inputHandle} type="password" />
                                        </>
                                    )}
                                </div>

                                {// Boutons }
                                <div className='flex gap-3 mt-4'>
                                    <button disabled={loader} className='bg-blue-500 text-white rounded-md px-7 py-2 w-full'>
                                        {loader ? <PropagateLoader color='#fff' cssOverride={overrideStyle} /> : 'Soumettre'}
                                    </button>
                                    {!customerInfo && (
                                        <button type="button" onClick={handleBack} className='bg-gray-400 text-white rounded-md px-7 py-2'>
                                            Retour
                                        </button>
                                    )}
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

// Champ de saisie réutilisable
const InputField = ({ label, name, value, onChange, type = 'text', required = true }) => (
    <div className='flex flex-col gap-1'>
        <label htmlFor={name}>{label}</label>
        <input
            type={type}
            name={name}
            id={name}
            placeholder={label}
            value={value}
            onChange={onChange}
            required={required}
            className='px-4 py-2 border border-slate-300 rounded-md focus:border-indigo-500 outline-none'
        />
    </div>
);

export default SellOnGobymall;
*/

import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { BsImages } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { FadeLoader, PropagateLoader } from "react-spinners";

import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import { useNavigate } from "react-router-dom";
import api from "../api/api";
import Footer from "../components/Footer";
import Headers from "../components/Headers";
import {
  createSellerAccount,
  customer_login,
  logout,
  messageClear,
} from "../store/reducers/authReducer";
import { useCategories } from "../utils/Categories";
import { overrideStyle } from "../utils/utils";

const SellOnGobymall = () => {
  const [authStep, setAuthStep] = useState(null);
  const [isLoggedInStepDone, setIsLoggedInStepDone] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const { categories, loading, errorMessage, clientLocation } = useCategories();
  const dispatch = useDispatch();
  const { customerInfo, loader, successMessage, messageError, newCustomerId } =
    useSelector((state) => state.auth);

  const navigate = useNavigate();

  const { t } = useTranslation();

  const [state, setState] = useState({
    country: "",
    city: "",
    shopName: "",
    address: "",
    telephone: "",
    email: "",
    password: "",
    image: {},
    name: "",
  });

  const [logState, setLogState] = useState({ email: "", password: "" });

  const inputLogHandle = (e) => {
    setLogState({ ...logState, [e.target.name]: e.target.value });
  };

  const handleBack = () => {
    if (authStep === "register") setAuthStep(null);
    else if (authStep === "login" && isLoggedInStepDone)
      setIsLoggedInStepDone(false);
    else setAuthStep(null);
  };

  /*const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) setSelectedImage(file);
    };*/

  const handleImageChange = (e) => {
    let files = e.target.files;
    if (files.length > 0) {
      setSelectedImage(URL.createObjectURL(files[0]));
      setState({
        ...state,
        image: files[0],
      });
    }
  };

  const inputHandle = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    setIsLoggedInStepDone(true);
    dispatch(customer_login(logState));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedImage) {
      toast.error(`${t("Please select an image.")}`);
      return;
    }

    const formData = new FormData();
    formData.append("shopName", state.shopName);
    formData.append("email", customerInfo?.email || state.email);
    formData.append("name", customerInfo?.name || state.name);
    if (!customerInfo) formData.append("password", state.password);
    formData.append("country", state.country);
    formData.append("city", state.city);
    formData.append("address", state.address);
    formData.append("telephone", state.telephone);
    formData.append("image", state.image);

    // 🔍 Voir le contenu
    /*for (let pair of formData.entries()) {
            console.log(pair[0] + ':', pair[1]);
        } */

    dispatch(createSellerAccount(formData));
  };

  useEffect(() => {
    const handleSwitchToSeller = async () => {
      try {
        if (customerInfo) {
          const customerId = customerInfo.id;

          // Redirection temporaire si nécessaire
          navigate("/");

          // Requête pour passer au compte vendeur
          const { data } = await api.get(
            `/api/customer/switch-to-seller/${customerId}`,
            {
              withCredentials: true,
            },
          );

          // Déconnexion du compte client
          await dispatch(logout());

          // Redirection vers l'interface vendeur
          const sellerRedirectUrl = `${data.redirect}?from=customer`;
          window.location.href = sellerRedirectUrl;
        } else if (newCustomerId) {
          toast(`${t("Verify account")}`);
          navigate(`/verify/account`);
        }
      } catch (error) {
        toast.error(`${t("No acount")}`);
      }
    };
    /*
       "Please select an image.":,
       "Verify account":,
       "No acount":

      */
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());

      // Réinitialisation du formulaire
      setState({
        country: "",
        city: "",
        shopName: "",
        address: "",
        telephone: "",
        email: "",
        password: "",
        image: {},
        name: "",
      });
      setSelectedImage("");

      // Passage au compte vendeur
      handleSwitchToSeller();
    }

    if (messageError) {
      toast.error(messageError);
      dispatch(messageClear());
    }
  }, [
    successMessage,
    messageError,
    dispatch,
    customerInfo,
    newCustomerId,
    navigate,
    t,
  ]);

  const Etatlogin =
    !customerInfo && authStep === "login" && !isLoggedInStepDone;

  return (
    <div>
      <Headers categories={categories} clientLocation={clientLocation} />

      {loading && (
        <div className='w-screen h-screen fixed inset-0 bg-gray-500/70 z-[99999] flex justify-center items-center'>
          <FadeLoader />
        </div>
      )}

      {errorMessage && (
        <div className='text-red-600 text-3xl font-bold text-center'>
          {errorMessage}
        </div>
      )}

      <div
        className={`${Etatlogin ? `py-6` : `min-h-screen`}  bg-[#eaebed] flex justify-center items-center text-slate-500`}
      >
        <div className='w-[50%] md-lg:w-[95%] p-4 sm:p-2'>
          <div className='bg-white p-4 sm:p-2 rounded-md'>
            {!customerInfo && !authStep && (
              <div className='text-center'>
                <h2 className='text-xl mb-10'>{t("must log in")}</h2>
                <div className='flex gap-4 justify-center'>
                  <button
                    onClick={() => setAuthStep("login")}
                    className='bg-blue-600 text-white px-4 py-2 rounded'
                  >
                    {t("Sign in")}
                  </button>
                  <button
                    onClick={() => setAuthStep("register")}
                    className='bg-green-600 text-white px-4 py-2 rounded'
                  >
                    {t("Create an account")}
                  </button>
                </div>
                <div className='flex justify-center items-center mt-5'>
                  <img
                    className='h-[350px] w-auto opacity-45'
                    src='/images/shiapp.jpg'
                    alt='Aperçu'
                  />
                </div>
              </div>
            )}

            {!customerInfo && authStep === "login" && !isLoggedInStepDone && (
              <form
                onSubmit={handleLoginSubmit}
                className='flex flex-col gap-4'
              >
                <h2 className='text-xl text-center sm:text-sm'>
                  {t("Log in to")}
                </h2>
                <InputField
                  label='Email'
                  name='email'
                  value={logState.email}
                  onChange={inputLogHandle}
                  type='email'
                />
                <InputField
                  label={t("Password")}
                  name='password'
                  value={logState.password}
                  onChange={inputLogHandle}
                  type='password'
                />
                <div className='flex gap-3'>
                  <button
                    type='submit'
                    className='bg-blue-500 text-white px-4 py-2 rounded w-full'
                  >
                    {t("Login")}
                  </button>
                  <button
                    type='button'
                    onClick={handleBack}
                    className='bg-gray-400 text-white px-4 py-2 rounded'
                  >
                    {t("Back")}
                  </button>
                </div>
              </form>
            )}

            {(customerInfo ||
              authStep === "register" ||
              (authStep === "login" && isLoggedInStepDone)) && (
              <form onSubmit={handleSubmit} className='flex flex-col gap-4'>
                <h2 className='text-center'>{t("You are about to")}</h2>
                <hr className='text-blue-400' />
                <div className='flex justify-center'>
                  {!selectedImage ? (
                    <label
                      htmlFor='img'
                      className='cursor-pointer border border-dashed border-[#d0d2d6] hover:border-indigo-500 h-[210px] w-[300px] flex flex-col items-center justify-center relative'
                    >
                      <BsImages size={32} />
                      <span>{t("Select an image")}</span>
                      {loader && (
                        <div className='absolute inset-0 bg-slate-600 opacity-70 flex justify-center items-center'>
                          <FadeLoader />
                        </div>
                      )}
                    </label>
                  ) : (
                    <img src={selectedImage} alt='' />
                  )}
                  <input
                    id='img'
                    type='file'
                    className='hidden'
                    onChange={handleImageChange}
                  />
                </div>

                {!customerInfo && (
                  <>
                    {" "}
                    <InputField
                      label={t("Your name")}
                      name='name'
                      value={state.name}
                      onChange={inputHandle}
                    />
                    <InputField
                      label='Email'
                      name='email'
                      value={state.email}
                      onChange={inputHandle}
                      type='email'
                    />
                    <InputField
                      label={t("Password")}
                      name='password'
                      value={state.password}
                      onChange={inputHandle}
                      type='password'
                    />
                  </>
                )}

                <InputField
                  label={t("Shop name")}
                  name='shopName'
                  value={state.shopName}
                  onChange={inputHandle}
                />
                <InputField
                  label={t("Country")}
                  name='country'
                  value={state.country}
                  onChange={inputHandle}
                />
                <InputField
                  label={t("City")}
                  name='city'
                  value={state.city}
                  onChange={inputHandle}
                />
                <InputField
                  label={t("Address")}
                  name='address'
                  value={state.address}
                  onChange={inputHandle}
                />
                <div className='flex flex-col w-[92%] gap-1 mb-3'>
                  <label className='text-sm text-slate-600'>{t("Phone")}</label>
                  <PhoneInput
                    // onlyCountries={['fr', 'tg', 'ci', 'bj', 'bf', 'sn']}
                    country={"tg"} // Par défaut le Togo
                    value={state.telephone}
                    onChange={(phone) =>
                      setState({ ...state, telephone: phone })
                    }
                    inputStyle={{
                      width: "100%",
                      padding: "12px",
                      border: "1px solid #e2e8f0",
                      borderRadius: "0.375rem",
                      left: "8%",
                    }}
                    enableSearch={true}
                  />
                </div>

                <div className='flex gap-3 mt-4'>
                  <button
                    disabled={loader}
                    className='bg-blue-500 text-white rounded-md px-7 py-2 w-full'
                  >
                    {loader ? (
                      <PropagateLoader
                        color='#fff'
                        cssOverride={overrideStyle}
                      />
                    ) : (
                      `${t("Submit")}`
                    )}
                  </button>
                  {!customerInfo && (
                    <button
                      type='button'
                      onClick={handleBack}
                      className='bg-gray-400 text-white rounded-md px-7 py-2'
                    >
                      {t("Back")}
                    </button>
                  )}
                </div>
              </form>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

const InputField = ({ label, name, value, onChange, type = "text" }) => (
  <div className='flex flex-col gap-1'>
    <label htmlFor={name}>{label}</label>
    <input
      type={type}
      name={name}
      id={name}
      placeholder={label}
      value={value}
      onChange={onChange}
      className='px-4 py-2 border border-slate-300 rounded-md focus:border-indigo-500 outline-none'
    />
  </div>
);

export default SellOnGobymall;
